module.exports = __webpack_public_path__ + "static/media/image003.905ab2e4.png";